if (!customElements.get('cart-discount-form')) {
  customElements.define(
    'cart-discount-form',
    class CartDiscountForm extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.form = this.querySelector('[data-cart-discount-form]');
        this.input = this.querySelector('[name="discount"]');
        this.status = this.querySelector('[data-cart-discount-status]');
        this.submitButton = this.form?.querySelector('[type="submit"]');
        this.form?.addEventListener('submit', (event) => this.applyDiscount(event));
      }

      async applyDiscount(event) {
        event.preventDefault();
        const code = this.input?.value.trim();
        const statusId = this.status?.id;
        if (!code) {
          this.setStatus('Enter a discount code first.', true);
          this.input?.focus();
          return;
        }

        this.setBusy(true);
        this.setStatus('Applying discount code…');

        try {
          const response = await fetch(routes.cart_update_url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              discount: code,
              sections: ['cart-drawer', 'main-cart', 'cart-icon-bubble'],
              sections_url: window.location.pathname,
            }),
          });
          const cart = await response.json();
          if (!response.ok || cart.status) {
            throw new Error(cart.description || cart.message || 'The discount code could not be applied.');
          }

          const cartDrawer = document.querySelector('cart-drawer');
          await cartDrawer?.renderContents({ sections: cart.sections }, true);

          const currentMainCart = document.querySelector('#main-cart');
          const mainCartSection = cart.sections?.['main-cart'];
          if (currentMainCart && mainCartSection) {
            const mainCartDocument = new DOMParser().parseFromString(mainCartSection, 'text/html');
            const refreshedMainCart = mainCartDocument.querySelector('#main-cart');
            if (refreshedMainCart) currentMainCart.replaceWith(refreshedMainCart);
          }

          const applications = cart.cart_level_discount_applications || [];
          const applied = applications.some((discount) =>
            String(discount.title || '').toLowerCase() === code.toLowerCase()
          );
          const refreshedStatus = statusId ? document.getElementById(statusId) : this.status;
          if (refreshedStatus) {
            refreshedStatus.textContent = applied
              ? 'Discount code applied.'
              : 'This discount code is not valid for the items in your cart.';
            refreshedStatus.classList.toggle('is-error', !applied);
          }
        } catch (error) {
          this.setStatus(error.message || 'The discount code could not be applied.', true);
        } finally {
          this.setBusy(false);
        }
      }

      setBusy(isBusy) {
        this.form?.setAttribute('aria-busy', String(isBusy));
        if (this.submitButton) this.submitButton.disabled = isBusy;
        if (this.input) this.input.disabled = isBusy;
      }

      setStatus(message, isError = false) {
        if (!this.status) return;
        this.status.textContent = message;
        this.status.classList.toggle('is-error', isError);
      }
    }
  );
}
